module.exports = __webpack_public_path__ + "img/erp1.7a288afe.png";